/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*

* Copyright (c) 2026.
* Orion Analytics.
* All Rights Reserved
  */

import Plot from "react-plotly.js";

export default function RollingSpreadChart({
    spreads = []
    }) {

    if (!spreads.length) {

        return (

            <div className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-6
                text-center
                text-slate-400
            ">
                No spread data available
            </div>

        );

    }

    const dates =
        spreads.map(
            row => row.date
        );

    const nearMid =
        spreads.map(
            row =>
                row.near_mid_spread
        );

    const midFar =
        spreads.map(
            row =>
                row.mid_far_spread
        );

    const latestNearMid =
        nearMid[
            nearMid.length - 1
        ];

    const latestMidFar =
        midFar[
            midFar.length - 1
        ];

    const avgNearMid =
        (
            nearMid.reduce(
                (a, b) => a + b,
                0
            ) / nearMid.length
        ).toFixed(2);

    const avgMidFar =
        (
            midFar.reduce(
                (a, b) => a + b,
                0
            ) / midFar.length
        ).toFixed(2);

    const StatCard = ({
        title,
        value
    }) => (

        <div className="
            bg-slate-900
            rounded-2xl
            p-4
        ">

            <div className="
                text-slate-400
                text-xs
                uppercase
                tracking-wide
            ">
                {title}
            </div>

            <div className="
                mt-2
                text-2xl
                font-bold
                text-white
            ">
                {value}
            </div>

        </div>

    );

    return (

        <div className="
            space-y-6
        ">

            {/* HEADER */}

            <div className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-6
            ">

                <div className="
                    flex
                    flex-col
                    lg:flex-row
                    lg:items-center
                    lg:justify-between
                    gap-6
                ">

                    <div>

                        <h2 className="
                            text-xl
                            font-bold
                            text-white
                        ">
                            NIFTY Futures Spread Curve
                        </h2>

                        <p className="
                            text-slate-400
                            mt-1
                        ">
                            Near-Mid and Mid-Far
                            expiry spread trends
                        </p>

                    </div>

                    <div className="
                        grid
                        grid-cols-2
                        lg:grid-cols-4
                        gap-3
                    ">

                        <StatCard
                            title="Latest Near-Mid"
                            value={latestNearMid?.toFixed(2)}
                        />

                        <StatCard
                            title="Latest Mid-Far"
                            value={latestMidFar?.toFixed(2)}
                        />

                        <StatCard
                            title="Avg Near-Mid"
                            value={avgNearMid}
                        />

                        <StatCard
                            title="Avg Mid-Far"
                            value={avgMidFar}
                        />

                    </div>

                </div>

            </div>

            {/* MAIN CHART */}

            <div className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-4
            ">

                <Plot

                    data={[

                        {
                            x: dates,

                            y: nearMid,

                            type: "scatter",

                            mode: "lines",

                            name: "Near-Mid",

                            line: {
                                width: 3,
                                color: "#22c55e"
                            }
                        },

                        {
                            x: dates,

                            y: midFar,

                            type: "scatter",

                            mode: "lines",

                            name: "Mid-Far",

                            line: {
                                width: 3,
                                color: "#3b82f6"
                            }
                        }

                    ]}

                    layout={{

                        height: 550,

                        paper_bgcolor:
                            "#020617",

                        plot_bgcolor:
                            "#020617",

                        font: {
                            color:
                                "#cbd5e1"
                        },

                        margin: {
                            l: 60,
                            r: 20,
                            t: 20,
                            b: 50
                        },

                        xaxis: {

                            title:
                                "Date",

                            type:
                                "date",

                            showgrid:
                                false
                        },

                        yaxis: {

                            title:
                                "Spread (Points)",

                            gridcolor:
                                "#1e293b",

                            zerolinecolor:
                                "#475569"
                        },

                        legend: {
                            orientation:
                                "h"
                        },

                        hovermode:
                            "x unified"
                    }}

                    config={{
                        responsive:
                            true,

                        displayModeBar:
                            false
                    }}

                    style={{
                        width: "100%"
                    }}

                />

            </div>

        </div>

    );

}
